export const GET_AVAILABLE_PMS = `query {
  get_available_pms {
    message
    data {
      id
      name
    }
  }
}`;

export const LIST_CONFIGURED_PMSS = `query {
  list_configured_pmss {
    message
    data {
      _id
      pms_id
      pms_name
      pms_access_key
      pms_urlname
      pms_property_id
      pms_group_id
      pms_is_active
    }
  }
}`;

export const ACTIVATE_PMS = `mutation {
  activate_pms {
    message
  }
}`;

export const ADD_NEW_PMS = `mutation ($pmsId: String!, $pmsAccessKey: String!, $pmsUrlname: String!, $pmsPropertyId: String!, $pmsGroupId: String) {
  add_new_pms(
    pms_id: $pmsId,
    pms_access_key: $pmsAccessKey,
    pms_urlname: $pmsUrlname,
    pms_property_id: $pmsPropertyId,
    pms_group_id: $pmsGroupId
  ) {
    message
  }
}`;

export const LIST_ROOMTYPE_PMSS = `query ($roomtypeId: String!) {
  list_roomtype_pmss(roomtype_id: $roomtypeId) {
    message
    data {
      _id
      pms_id
      pms_name
      pms_roomtype_id
      is_active
    }
  }
}`;

export const ADD_ROOMTYPE_PMS = `mutation ($id: String!, $pmsId: String!, $pmsName: String!, $pmsRoomtypeId: String!) {
  add_roomtype_pms(
    _id: $id,
    pms_id: $pmsId,
    pms_name: $pmsName,
    pms_roomtype_id: $pmsRoomtypeId
  ) {
    message
  }
}`;

export const ACTIVATE_ROOMTYPE_PMS = `mutation ($id: String!) {
  activate_roomtype_pms(_id: $id) {
    message
  }
}`;

export const UPDATE_PMS = `mutation ($pmsId: String!, $pmsAccessKey: String!, $pmsUrlname: String!, $pmsPropertyId: String!, $pmsGroupId: String) {
  update_pms(
    pms_id: $pmsId,
    pms_access_key: $pmsAccessKey,
    pms_urlname: $pmsUrlname,
    pms_property_id: $pmsPropertyId,
    pms_group_id: $pmsGroupId
  ) {
    message
  }
}`;

export const UPDATE_ROOMTYPE_PMS = `mutation ($id: String!, $pmsId: String!, $pmsName: String!, $pmsRoomtypeId: String!) {
  update_roomtype_pms(
    _id: $id,
    pms_id: $pmsId,
    pms_name: $pmsName,
    pms_roomtype_id: $pmsRoomtypeId
  ) {
    message
  }
}`;

export const LIST_ALL_PMS_RATEPLANS = `query ($roomtypeId: String!) {
  list_all_pms_rateplans(roomtype_id: $roomtypeId) {
    message
    data {
      _id
      pms_id
      pms_rate_code
      name
      description
      is_active
      meal_plan_id {
        _id
        name
      }
    }
  }
}`;

export const ADD_NEW_ROOMTYPE_PMS_RATEPLAN = `mutation ($id: String!, $pmsId: Int!, $pmsRateCode: String!, $mealPlanId: String, $name: String, $description: String) {
  add_new_roomtype_pms_rateplan(_id: $id, pms_id: $pmsId, pms_rate_code: $pmsRateCode, meal_plan_id: $mealPlanId, name: $name, description: $description) {
    message
  }
}`;

export const UPDATE_ROOMTYPE_PMS_RATEPLAN = `mutation ($id: String!, $roomtypeId: String!, $pmsId: Int!, $pmsRateCode: String!, $mealPlanId: String, $name: String, $description: String) {
  update_roomtype_pms_rateplan(_id: $id, roomtype_id: $roomtypeId, pms_id: $pmsId, pms_rate_code: $pmsRateCode, meal_plan_id: $mealPlanId, name: $name, description: $description) {
    message
  }
}`;

export const ACTIVATE_PMS_RATEPLAN = `mutation ($id: String!) {
  activate_pms_rateplan(_id: $id) {
    message
  }
}`;

export const LIST_ALL_PMS_UPDATES = `query ($pageSize: Int, $pageNumber: Int, $startDate: Int, $endDate: Int) {
  list_all_pms_updates(page_size: $pageSize, page_number: $pageNumber, start_date: $startDate, end_date: $endDate){
    message
    data {
      _id
      start_date
      end_date
      avail_count
      cron_avail_count
      stop_sell
      roomtype_id {
        _id
        name
      }
    }
    hasMore
    count
  }
}`;

export const LIST_PMS_UPDATE_DETAILS = `query ($id: String!) {
  list_pms_update_details(_id: $id){
    message
    data {
      _id
      start_date
      end_date
      avail_count
      cron_avail_count
      stop_sell
      created_at
      updated_at
      cron_updated_at
      pms_hotel_id
      pms_room_id
      roomtype_id {
        _id
        name
        description
      }
    }
  }
}`;
